import React, { FC } from "react";

interface Props {
  label: string;
  required?: boolean;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  errorMessage?: string;
}

export const FormSelect: FC<Props> = ({
  label,
  required,
  value,
  options,
  onChange,
  errorMessage,
}) => {
  const [showOptions, setShowOptions] = React.useState(false);
  const dropdownDOM = React.useRef<HTMLDivElement>(null);

  const handleChange = (val: string) => {
    onChange(val);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownDOM.current &&
      !dropdownDOM.current.contains(event.target as any) &&
      !(event as any).target?.closest(".formSelect--toggler")
    ) {
      setShowOptions(false);
    }
  };

  React.useEffect(() => {
    if (showOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOptions]);

  return (
    <div className="formSelect">
      <button
        className="formSelect--toggler"
        type="button"
        onClick={() => {
          setShowOptions(!showOptions);
        }}
      >
        {label} {!required && <span>(Optional)</span>}
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="keyboard_arrow_down">
            <path
              id="Vector"
              d="M6 9L10 11L14 9"
              stroke="#2F323A"
              strokeWidth="2"
            />
          </g>
        </svg>
      </button>
      <div className="formSelect--value">
        <span>{value || ""}</span>
        {value && (
          <button
            onClick={() => {
              handleChange("");
            }}
            type="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        )}
      </div>
      {showOptions && (
        <div ref={dropdownDOM} className="formSelect--options">
          {options.map((option, index) => {
            return (
              <button
                key={index}
                type="button"
                onClick={() => {
                  handleChange(option);
                  setShowOptions(false);
                }}
              >
                {option}
              </button>
            );
          })}
        </div>
      )}
      {errorMessage && (
        <span className="formSelect--error">{errorMessage}</span>
      )}
    </div>
  );
};
